/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  KlaviyoList,
  SyncCompaniesToKlaviyoRequest,
  SyncCompaniesToKlaviyoResult,
} from "../models/index";
import {
  KlaviyoListFromJSON,
  KlaviyoListToJSON,
  SyncCompaniesToKlaviyoRequestFromJSON,
  SyncCompaniesToKlaviyoRequestToJSON,
  SyncCompaniesToKlaviyoResultFromJSON,
  SyncCompaniesToKlaviyoResultToJSON,
} from "../models/index";

export interface SyncCompaniesToListRequest {
  syncCompaniesToKlaviyoRequest: SyncCompaniesToKlaviyoRequest;
}

/**
 *
 */
export class KlaviyoApi extends runtime.BaseAPI {
  /**
   * Get all Klaviyo lists
   */
  async getListsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<KlaviyoList>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/klaviyo/get-lists`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(KlaviyoListFromJSON),
    );
  }

  /**
   * Get all Klaviyo lists
   */
  async getLists(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<KlaviyoList>> {
    const response = await this.getListsRaw(initOverrides);
    return await response.value();
  }

  /**
   * Sync the given companies\' contacts into a Klaviyo list
   */
  async syncCompaniesToListRaw(
    requestParameters: SyncCompaniesToListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SyncCompaniesToKlaviyoResult>> {
    if (requestParameters["syncCompaniesToKlaviyoRequest"] == null) {
      throw new runtime.RequiredError(
        "syncCompaniesToKlaviyoRequest",
        'Required parameter "syncCompaniesToKlaviyoRequest" was null or undefined when calling syncCompaniesToList().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/klaviyo/sync-companies-to-list`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SyncCompaniesToKlaviyoRequestToJSON(
          requestParameters["syncCompaniesToKlaviyoRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SyncCompaniesToKlaviyoResultFromJSON(jsonValue),
    );
  }

  /**
   * Sync the given companies\' contacts into a Klaviyo list
   */
  async syncCompaniesToList(
    requestParameters: SyncCompaniesToListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SyncCompaniesToKlaviyoResult> {
    const response = await this.syncCompaniesToListRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
